function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class GaiaMenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();

    console.log(this);
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (
      !openDetailsElement ||
      openDetailsElement.getAttribute("disabled") !== null
    )
      return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("gaia-menu-drawer", GaiaMenuDrawer);

class GaiaHeaderDrawer extends GaiaMenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.querySelector(".shopify-section.section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("gaia-header-drawer", GaiaHeaderDrawer);

class GaiaHeader extends HTMLElement {
  constructor() {
    super();

    let gaiaHeader = this;

    window.addEventListener("scroll", () => {
      let headerRect = gaiaHeader.getBoundingClientRect();
      let headerPos = 0;
      if (window.scrollY === 0) {
        headerPos = 20; // Always show header at top
      } else if (window.scrollY > this.previousScroll) {
        // scrolling down
        headerPos = 0 - headerRect.height;
      } else {
        // scrolling up
        headerPos = 20;
      }
      this.style.top = `${headerPos}px`;
      this.previousScroll = window.scrollY;
    });
    this.addEventListener("click", () => {
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.getBoundingClientRect().bottom)}px`
      );
    });

    // Close on esc key
    window.addEventListener("keyup", (e) => {
      if (e.code === "Escape" || e.key === "Escape") {
        // Remove overflow-hidden from body
        document.body.classList.remove("overflow-hidden");
        document
          .querySelectorAll(".shopify-section.section-header details[open]")
          .forEach((openDetails) => {
            openDetails.removeAttribute("open");
            const summary = openDetails.querySelector("summary");
            if (summary) summary.setAttribute("aria-expanded", "false");
          });

        const header = document.querySelector(
          ".shopify-section.section-header"
        );
        if (header) header.classList.remove("menu-open");
      }
    });

    let mobileMenuCurrentLevel = "0";
    let mobileMenuCurrentParent = null;

    // Mobile menu tiers
    const setupMobileMenuDrilldown = () => {
      const menuRoot = document.getElementById("mobile-menu-drilldown");
      if (!menuRoot) return;
      if (window.innerWidth >= 1232) return;

      // Try to restore previous state
      let selector = `.mobile-menu-view[data-level="${mobileMenuCurrentLevel}"]`;
      if (mobileMenuCurrentParent)
        selector += `[data-parent="${mobileMenuCurrentParent}"]`;
      let viewToShow =
        menuRoot.querySelector(selector) ||
        menuRoot.querySelector('.mobile-menu-view[data-level="0"]');

      // Hide all views
      menuRoot.querySelectorAll(".mobile-menu-view").forEach((view) => {
        view.style.display = "none";
      });

      // Show the correct view
      if (viewToShow) viewToShow.style.display = "";

      let currentView = viewToShow;

      menuRoot.addEventListener("click", function (e) {
        const nextBtn = e.target.closest("button.mobile-menu-next");
        const backBtn = e.target.closest("button.mobile-menu-back");

        if (nextBtn) {
          const index = nextBtn.getAttribute("data-index");
          currentView.style.display = "none";
          const nextView = menuRoot.querySelector(
            `.mobile-menu-view[data-parent="${index}"]`
          );
          if (nextView) {
            nextView.style.display = "";
            currentView = nextView;
            // Store state
            mobileMenuCurrentLevel = nextView.getAttribute("data-level");
            mobileMenuCurrentParent = nextView.getAttribute("data-parent");
          }
        }
        if (backBtn) {
          const parentLevel =
            parseInt(currentView.getAttribute("data-level")) - 1;
          let parentView;
          if (parentLevel === 0) {
            parentView = menuRoot.querySelector(
              '.mobile-menu-view[data-level="0"]'
            );
          } else {
            const parentIndex = currentView
              .getAttribute("data-parent")
              .split("-")[0];
            parentView = menuRoot.querySelector(
              `.mobile-menu-view[data-level="${parentLevel}"][data-parent="${parentIndex}"]`
            );
          }
          if (parentView) {
            currentView.style.display = "none";
            parentView.style.display = "";
            currentView = parentView;
            // Store state
            mobileMenuCurrentLevel = parentView.getAttribute("data-level");
            mobileMenuCurrentParent = parentView.getAttribute("data-parent");
          }
        }
      });
    };

    window.addEventListener("DOMContentLoaded", setupMobileMenuDrilldown);
    window.addEventListener("resize", setupMobileMenuDrilldown);
    setupMobileMenuDrilldown();
  }
}

customElements.define("gaia-header", GaiaHeader);

class GaiaDropdown extends HTMLElement {
  constructor() {
    super();

    this.details = this.querySelector("details");
    this.summary = this.querySelector("summary");
    this.content = this.querySelector("summary + *");

    this.details.classList.add("closed");

    if (this.content.getAttribute("tabindex") === null)
      this.content.setAttribute("tabindex", "0");

    this.summary.addEventListener("click", (e) => {
      this.click(e);
    });

    this.clickOffListener = this.clickOff.bind(this);
  }

  clickOff(e) {
    if (this.details.open && !this.contains(e.target)) {
      this.close();
    }
  }

  click(e) {
    e.preventDefault();
    if (
      this.details.open ||
      this.details.classList.contains("opening") ||
      this.details.classList.contains("open")
    ) {
      this.close();
    } else {
      this.open();
    }
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      let ariaLabel = detailsElement.getAttribute("aria-label") || "";
      if (detailsElement.hasAttribute("open")) {
        ariaLabel = ariaLabel.replace("Open", "Close");
      } else {
        ariaLabel = ariaLabel.replace("Close", "Open");
      }
      detailsElement.setAttribute("aria-label", ariaLabel);
    }
  }

  open() {
    // Close all other open GaiaDropdowns in the document
    document
      .querySelectorAll("gaia-dropdown details[open]")
      .forEach((details) => {
        if (details !== this.details) {
          details.removeAttribute("open");
          details.classList.remove("open");
          details.classList.remove("opening");
          details.classList.add("closed");
        }
      });

    this.details.classList.remove("closed");
    this.details.classList.remove("closing");
    this.details.classList.add("opening");
    this.details.setAttribute("open", true);

    if (!this.closest("details") && this.closest("header")) {
      document.body.classList.add("overflow-hidden");
    }
    setTimeout(() => {
      this.details.classList.remove("opening");
      this.details.classList.add("open");
      if (this.closest("header")) {
        document.body.classList.add("overflow-hidden");
      }
    }, 300);

    this.updateAriaLabel();
    document.addEventListener("click", this.clickOffListener);
  }

  close() {
    this.details.classList.remove("open");
    this.details.classList.remove("opening");
    this.details.classList.add("closing");
    if (!this.closest("details"))
      document.body.classList.remove("overflow-hidden");
    setTimeout(() => {
      this.details.removeAttribute("open");
      this.details.classList.remove("open");
      this.details.classList.remove("closing");
      this.details.classList.add("closed");
    }, 300);
    document.removeEventListener("click", this.clickOffListener);
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
}

customElements.define("gaia-dropdown", GaiaDropdown);

class GaiaSelect extends GaiaDropdown {
  constructor() {
    super();

    this.selectedOption = this.querySelector(".selected-option");
    this.fieldset = this.querySelector("fieldset");
    this.options = this.querySelector(".options");
    this.summary = this.querySelector("summary");
    //Looking for  <gaia-select data-subscription-widget="true"></gaia-select>
    this.isSubscriptionWidget = this.hasAttribute("data-subscription-widget");

    this.options.removeAttribute("tabindex");

    this.fieldset.addEventListener("change", (event) => {
      // Workaround for subscription widgets, as value is needed for adding correct subscription
      if (this.isSubscriptionWidget) {
        this.selectedOption.innerText =
          this.querySelector("input:checked").getAttribute("radio-name");
      } else {
        this.selectedOption.innerText =
          this.querySelector("input:checked").value;
      }
      console.log(event.detail);
      // this.summary.click();
    });
  }
}

customElements.define("gaia-select", GaiaSelect);

class GaiaMobileMenu extends GaiaDropdown {
  constructor() {
    super();

    // Listen for breakpoint changes and close menu if crossing 1232px
    let lastIsMobile = window.innerWidth <= 1232;
    window.addEventListener("resize", () => {
      const isMobile = window.innerWidth <= 1232;
      if (isMobile !== lastIsMobile) {
        // If breakpoint changed, close the menu
        const details = this.querySelector("details");
        if (details && details.hasAttribute("open")) {
          this.close();
        }
      }
      lastIsMobile = isMobile;
    });
  }

  updateAriaLabel() {
    const detailsElement = this.querySelector("details");
    if (detailsElement) {
      if (detailsElement.hasAttribute("open")) {
        detailsElement.setAttribute("aria-label", "Close Main Menu");
      } else {
        detailsElement.setAttribute("aria-label", "Open Main Menu");
      }
    }
  }

  open() {
    this.header =
      this.header ||
      document.querySelector(".shopify-section.section-header gaia-header");
    if (this.header)
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom)}px`
      );
    super.open();
    this.updateAriaLabel();
  }

  close() {
    console.log("closing");
    super.close();
    setTimeout(() => {
      this.updateAriaLabel();
    }, 300); //Delay to allow attributes to be updated
  }
}

customElements.define("gaia-mobile-menu", GaiaMobileMenu);
